import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Placeholder } from '../assets/images/subtract.svg';
import { initModal } from '../constant/InitialData';
import { OrganisationContext } from '../context/organisationContext';
import { createSigner, updateSigner, deleteSigner } from '../store/features/formsSlice';
import { addToast } from '../store/features/toastSlice';
import CommonPopup from './common-popup';
import { AddFormWrapper } from './modal.styled';

const AddSigner = () => {
  const { setModal, modal } = useContext(OrganisationContext);
  const { onSuccess = () => {}, updatedSigner, versionId, deletedSigner } = modal.content;
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [signer, setSigner] = useState(updatedSigner);
  const [error, setError] = useState({});

  const checkSignerErrors = () => {
    if (!signer?.name?.trim()) {
      setError({
        name: !signer?.name?.trim(),
      });
      dispatch(addToast({ error: true, text: 'Please fill all required fields' }));
      return true;
    }
    return false;
  };

  const onConfirmAction = async () => {
    if (!deletedSigner) {
      if (loading || checkSignerErrors()) {
        return;
      }
    }
    setLoading(true);
    const request = {
      name: signer?.name,
    };

    if (deletedSigner) {
      dispatch(deleteSigner({ id: deletedSigner?.id, versionId: versionId }))
        .then(response => {
          if (onSuccess)
            onSuccess(
              dispatch(
                addToast({ error: false, title: 'Update Signer', text: 'signer has been successfully delteted ' }),
              ),
            );

          setModal(initModal);
        })
        .catch(err => {
          dispatch(addToast({ error: true, text: 'signer has been not deleted' }));
          console.log(err);
        });
    } else if (updatedSigner) {
      dispatch(updateSigner({ id: signer?.id, versionId: versionId, request: { name: signer?.name } }))
        .then(response => {
          if (onSuccess)
            onSuccess(
              dispatch(
                addToast({ error: false, title: 'Update Signer', text: 'signer has been successfully updated ' }),
              ),
            );

          setModal(initModal);
        })
        .catch(err => {
          dispatch(addToast({ error: true, text: 'signer has been not updated' }));
          console.log(err);
        });
    } else {
      dispatch(createSigner({ request: { ...request }, versionId: versionId }))
        .then(response => {
          if (onSuccess)
            onSuccess(
              dispatch(addToast({ error: false, title: 'Add Signer', text: 'signer has been successfully created ' })),
            );

          setModal(initModal);
        })
        .catch(err => {
          dispatch(addToast({ error: true, text: 'signer has been not create' }));
          console.log(err);
        });
    }
  };

  return (
    <div>
      <CommonPopup
        popupTitle={deletedSigner ? `Delete ${deletedSigner.name}` : updatedSigner ? 'Update Signer' : `Add Signer`}
        confirmButtonProps={{ label: deletedSigner ? 'Delete' : updatedSigner ? 'Update' : 'Add' }}
        disabled={loading}
        onCancel={() => setModal(initModal)}
        onConfirm={onConfirmAction}>
        <AddFormWrapper className="flex-column items-center w-full">
          {deletedSigner ? (
            <div className="w-full flex-column mt-6">
              <label className="regular-text font-16">Are you sure you want to delete this signer?</label>
            </div>
          ) : (
            <div className="w-full flex-column mt-6">
              <label className="regular-text lighter-text mb-1 font-12">{t('NAME')}</label>
              <input
                autoComplete="turnoff"
                className={`input ${error?.name && 'error-border'}`}
                onChange={e => {
                  setSigner({ ...signer, name: e.target.value });
                  setError({ ...error, name: false });
                }}
                placeholder="Signer name"
                value={signer?.name || ''}
              />
            </div>
          )}
        </AddFormWrapper>
      </CommonPopup>
    </div>
  );
};

export default AddSigner;
